(function () {
  if (window.__lpCollapsibleInit) return;
  window.__lpCollapsibleInit = true;

  // Cut height: fixed (data-lp-collapsible-height) or, if data-lp-collapsible-after-heading="N"
  // is set, computed to fall N headings deep (+ offset) — used by the product description
  // so the fade covers the first list items, not the heading itself.
  function cutHeightFor(el) {
    var after = parseInt(el.getAttribute('data-lp-collapsible-after-heading'), 10);
    if (after) {
      var headings = el.querySelectorAll('h1, h2, h3, h4, h5, h6');
      if (headings.length >= after) {
        var h = headings[after - 1];
        var offset = parseInt(el.getAttribute('data-lp-collapsible-offset'), 10);
        if (isNaN(offset)) offset = 80;
        return Math.round(h.getBoundingClientRect().top - el.getBoundingClientRect().top + h.offsetHeight + offset);
      }
    }
    return parseInt(el.getAttribute('data-lp-collapsible-height'), 10) || 200;
  }

  function makeCollapsible(el) {
    if (el._lpCollapsibleDone) return;
    el._lpCollapsibleDone = true;

    var cut = cutHeightFor(el);
    if (el.scrollHeight <= cut + 20) return;

    el.style.maxHeight = cut + 'px';
    el.classList.add('lp-collapsible--truncated');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lp-collapsible__more';
    btn.textContent = el.getAttribute('data-lp-more') || 'Pokaż więcej';
    el.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      el.style.maxHeight = '';
      el.classList.remove('lp-collapsible--truncated');
      btn.remove();
    });
  }

  // Inside a closed <details> the element has no height yet — wait until it opens.
  function process(el) {
    var details = el.closest('details');
    if (details && !details.open) {
      details.addEventListener('toggle', function onToggle() {
        if (details.open) {
          makeCollapsible(el);
          details.removeEventListener('toggle', onToggle);
        }
      });
    } else {
      makeCollapsible(el);
    }
  }

  function init() {
    document.querySelectorAll('[data-lp-collapsible]').forEach(process);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
